import React, { useState, useEffect, useContext, useRef } from "react";
import { scroll } from "../../Uitls/ScrollDiv";
import Canvas from "./Canvas";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import ValueContext from "../../ContextAPi/appContext";
import {
  getValidInput,
  sanitizeDecimalFieldValue,
  TIMELINE_DECIMAL_FIELDS,
  normalizeTimelinePopUpOptions,
  roundTo2Decimals,
  shouldPreserveDecimalInput,
} from "../../Uitls/Util";
import Powericon from "../../images/PowerIcon.svg";
import Dragger from "../../images/Dragger.svg";
import { Rnd } from "react-rnd";
import CustomanimationPopup from "../TimelineComps/CustomanimationPopup";
import LayerContextmenu from "../AnimationTimeLinePanel/LayerContextmenu";
import CopyPasteContextMenu from "../TimelineComps/CopyPasteContextMenu";
import "../../styles/components/AnimationTimeLine.scss";
import {
  buildHitAreaAnimationArray,
  getHitAreaKeyframesForAnimation,
  getImageTimelineRangeFromLayerWidth,
  MIN_RECT_SIZE,
  syncHitAreasToParentTimelineRange,
  toNumber,
} from "../RightPanel/HitAreaModal/utils";

function Layers({
  handleCtrlClick,
  handleCompAspectRatioPopup,
  isAspectRatioLocked,
  layerCompData,
  setLayerCompData,
  setMillSeconds,
  setSeconds,
  selectedComponent,
  setSelectedComponent,
  marker,
  setMarker,
  animationObject,
  setAnimationObject,
  popUpOptions,
  setPopUpOptions,
  copiedKeyFrame,
  setCopiedKeyFrame,
  setEdited,
  openTimelinePopup,
  setOpenTimelinePopup,
  setundoFlag,
  popUpValuesEdited,
  setPopUpValuesEdited,
  playPause,
  popUpLeft,
  SetPopupLeft,
  draggerWidth,
  setDraggerWidth,
  totalDuration,
  setTotalDuration,
  addKeyFrames,
  showTooltip,
  setShowTooltip,
  handleTimelinePopup,
  clickedClose,
  setClickedClose,
  setMultiSelectedComps,
  multiSelectedComps,
  keyFrameClicked,
  setKeyFrameClicked,
  updateKeyFrames,
  popUpWindowPosn,
  setPopWindowPosn,
  contextMenuvisbility,
  setContextMenuvisibility,
  deleteComponentOnCanvas,
  isNewAnimationOpen,
  setIsNewAnimationOpen,
  copyPasteContextMenuVisibility,
  setCopyPasteContextMenuVisibility,
  setSelectedProperties,
  selectedProperties,
  setSelectedPropertiesIndex,
  selectedPropertiesIndex,
  setCopyPropertySelected,
  copyPropertySelected,
  setCopyPasteContextMenuPosition,
  copyPasteContextMenuPosition,
  layerColDivRef,
}) {
  useEffect(() => {
    setMarker(0);
    setSeconds(0);
    setMillSeconds(0);
  }, [selectedComponent?.id]);
  const { t } = useTranslation();
  const layercontextMenuRef = useRef([]);
  const [elementPopUp, setElementPopUp] = useState(false);
  const [popUpName, setPopUpName] = useState(false);
  const [isResizing, setIsResizing] = useState(false);
  const [mouseUpOnTimeline, setMousUpOnTimeline] = useState(true);
  // Draft width while dragging the selected layer handle (controlled Rnd size).
  const [layerResizeDraftWidth, setLayerResizeDraftWidth] = useState(null);
  const layerResizeDraftWidthRef = useRef(null);
  const appData = useContext(ValueContext);
  const myDurationRef = React.useRef(totalDuration);
  const sLeftRef = useRef(marker);
  const draggerWidthRef = useRef(draggerWidth);
  const selectedComponentRef = useRef(selectedComponent);
  const layerCompDataRef = useRef(layerCompData);
  const lastTimelineStateRef = useRef({
    marker: null,
    seconds: null,
    milliseconds: null,
  });
  useEffect(() => {
    sLeftRef.current = marker || 0;
  }, [marker]);
  useEffect(() => {
    myDurationRef.current = totalDuration;
  }, [totalDuration]);
  useEffect(() => {
    draggerWidthRef.current = draggerWidth;
  }, [draggerWidth]);

  // If the timeline bar shrinks, clamp any layer that now exceeds it.
  useEffect(() => {
    const timelineLimit = toNumber(draggerWidth, 0);
    if (timelineLimit < 47) return;

    let didClamp = false;
    const nextLayers = layerCompData.map((entry) => {
      const width = toNumber(entry?.componentStyles?.layerWidth, 0);
      if (width > timelineLimit) {
        didClamp = true;
        return {
          ...entry,
          componentStyles: {
            ...entry.componentStyles,
            layerWidth: timelineLimit,
          },
        };
      }
      return entry;
    });

    if (!didClamp) return;

    setLayerCompData(nextLayers);
    if (
      selectedComponent?.id &&
      toNumber(selectedComponent?.componentStyles?.layerWidth, 0) > timelineLimit
    ) {
      setSelectedComponent({
        ...selectedComponent,
        componentStyles: {
          ...selectedComponent.componentStyles,
          layerWidth: timelineLimit,
        },
      });
    }
  }, [draggerWidth]);

  useEffect(() => {
    selectedComponentRef.current = selectedComponent;
  }, [selectedComponent]);
  useEffect(() => {
    layerCompDataRef.current = layerCompData;
  }, [layerCompData]);
  useEffect(() => {
    layerResizeDraftWidthRef.current = null;
    setLayerResizeDraftWidth(null);
  }, [selectedComponent?.id]);
  useEffect(() => {
    // While the global timeline is being dragged, drop any layer-resize draft
    // so the selected bar cannot visually track draggerWidth.
    if (!isResizing) return;
    layerResizeDraftWidthRef.current = null;
    setLayerResizeDraftWidth(null);
  }, [isResizing]);

  // Max playhead px for the selected layer; falls back to the global duration bar.
  const getMaxMarkerLeftForSelectedLayer = () => {
    const canvasMax = Math.max(0, (myDurationRef.current?.width || 0) - 10);
    const globalBarMax = Math.max(
      0,
      Math.min(toNumber(draggerWidthRef.current, canvasMax), canvasMax),
    );
    const selected = selectedComponentRef.current;
    const layers = layerCompDataRef.current || [];
    const liveSelected =
      selected?.id != null
        ? layers.find((entry) => entry?.id === selected.id)
        : null;
    const layerWidth = toNumber(
      liveSelected?.componentStyles?.layerWidth ??
        selected?.componentStyles?.layerWidth,
      0,
    );
    if (layerWidth > 0) {
      return Math.max(0, Math.min(layerWidth, globalBarMax || canvasMax));
    }
    return globalBarMax || canvasMax;
  };

  useEffect(() => {
    const maxLeft = getMaxMarkerLeftForSelectedLayer();
    if (sLeftRef.current > maxLeft) {
      sLeftRef.current = maxLeft;
      setMarker(0);
      const markerInSeconds = maxLeft / 45;
      let secondsToSet = Math.floor(markerInSeconds);
      let snappedMilliseconds =
        Math.round(((markerInSeconds - secondsToSet) * 100) / 10) * 10;
      if (snappedMilliseconds >= 100) {
        secondsToSet += 1;
        snappedMilliseconds = 0;
      }
      const normalizedSeconds = secondsToSet < 0 ? 0 : secondsToSet;
      setSeconds(normalizedSeconds);
      setMillSeconds(snappedMilliseconds);
      lastTimelineStateRef.current = {
        marker: maxLeft,
        seconds: normalizedSeconds,
        milliseconds: snappedMilliseconds,
      };
    }
  }, [
    selectedComponent?.id,
    selectedComponent?.componentStyles?.layerWidth,
    layerCompData,
    draggerWidth,
    totalDuration?.width,
  ]);

  const validateActionEdit = (component = selectedComponent) => {
    const styles = layerCompData.find(
      (selComp) => selComp.id === component?.id,
    )?.componentStyles;

    if (styles?.lockBoolean && styles?.hideBoolean) {
      toast(
        <div className="notificationText">
          {t("Component is locked and hidden!")}
        </div>,
        { type: "error", autoClose: 3000 },
      );
      return false;
    }
    if (styles?.lockBoolean) {
      toast(
        <div className="notificationText">{t("Component is Locked!")}</div>,
        { type: "error", autoClose: 3000 },
      );

      return false;
    }
    if (styles?.hideBoolean) {
      toast(
        <div className="notificationText">{t("Component is hidden!")}</div>,
        { type: "error", autoClose: 3000 },
      );
      return false;
    }
    return true;
  };
  const openCustomAnmnPopup = () => {
    setOpenTimelinePopup({
      popupWindow: !openTimelinePopup.popupWindow,
      fromUnRedo: false,
    });

    setElementPopUp(false);
    setCopyPasteContextMenuVisibility(false);
  };
  const callOnResizeStop = (e, direction, ref, _delta, _position, explicitWidth) => {
    const timelineLimit = Math.max(47, toNumber(draggerWidth, 0));
    let resizedLayerWidth =
      toNumber(explicitWidth, 0) ||
      toNumber(ref?.offsetWidth, 0) ||
      toNumber(parseFloat(ref?.style?.width), 0);

    // Fallback: older mouse-position measurement if DOM width is unavailable.
    if (!resizedLayerWidth) {
      const leftScrollValue = document
        .getElementById("layerCol")
        ?.getBoundingClientRect()?.left;
      resizedLayerWidth =
        (e?.clientX ?? e?.x ?? 0) - (leftScrollValue || 0) - 4;
    }

    // Layer bar cannot extend past the timeline limit (resizableDiv / draggerWidth).
    resizedLayerWidth = Math.min(
      Math.max(47, resizedLayerWidth),
      timelineLimit,
    );

    const selected = selectedComponentRef.current;
    if (!selected?.id) return;

    const previousLayerWidth = toNumber(
      selected?.componentStyles?.layerWidth,
      resizedLayerWidth
    );
    const scale = totalDuration || appData?.genericInfo?.canvasScale || {};
    const totalDurationInSeconds = toNumber(scale.divisions, 30);
    const totalDurationWidth = toNumber(
      scale.width,
      totalDurationInSeconds * 45
    );
    const timelineStart = selected?.componentStyles?.timelineStart;
    const previousParentRange = getImageTimelineRangeFromLayerWidth(
      previousLayerWidth,
      {
        totalDurationInSeconds,
        totalDurationWidth,
        timelineStart,
      }
    );
    const nextParentRange = getImageTimelineRangeFromLayerWidth(
      resizedLayerWidth,
      {
        totalDurationInSeconds,
        totalDurationWidth,
        timelineStart,
      }
    );

    const shouldSyncHitAreas =
      selected?.componentType === "Image" &&
      Array.isArray(selected?.componentStyles?.hitAreas) &&
      selected.componentStyles.hitAreas.length > 0 &&
      (previousParentRange.timelineStart !== nextParentRange.timelineStart ||
        previousParentRange.timelineEnd !== nextParentRange.timelineEnd);

    const syncedHitAreas = shouldSyncHitAreas
      ? syncHitAreasToParentTimelineRange(
          selected.componentStyles.hitAreas,
          previousParentRange,
          nextParentRange,
          {
            imageWidth: Math.max(
              MIN_RECT_SIZE,
              toNumber(selected?.componentStyles?.width, 0) >=
                MIN_RECT_SIZE
                ? toNumber(selected?.componentStyles?.width, 0)
                : toNumber(
                    selected?.componentStyles?.hitAreaAuthoringWidth,
                    MIN_RECT_SIZE
                  )
            ),
            imageHeight: Math.max(
              MIN_RECT_SIZE,
              toNumber(selected?.componentStyles?.height, 0) >=
                MIN_RECT_SIZE
                ? toNumber(selected?.componentStyles?.height, 0)
                : toNumber(
                    selected?.componentStyles?.hitAreaAuthoringHeight,
                    MIN_RECT_SIZE
                  )
            ),
            totalDurationInSeconds,
          }
        )
      : null;

    const nextStylesPatch = {
      layerWidth: resizedLayerWidth,
      ...(syncedHitAreas ? { hitAreas: syncedHitAreas } : {}),
    };

    setSelectedComponent({
      ...selected,
      componentStyles: {
        ...selected.componentStyles,
        ...nextStylesPatch,
      },
    });

    setLayerCompData((prev) =>
      prev.map((entry) => {
        if (entry.id !== selected.id) {
          return entry;
        }
        return {
          ...entry,
          componentStyles: {
            ...entry.componentStyles,
            ...nextStylesPatch,
          },
        };
      }),
    );

    if (syncedHitAreas) {
      setAnimationObject((previousAnimationObject) => {
        const nextAnimationObject = { ...previousAnimationObject };
        syncedHitAreas.forEach((hitArea) => {
          if (!hitArea?.id) return;
          if (hitArea.hideBoolean) {
            delete nextAnimationObject[hitArea.id];
            return;
          }
          nextAnimationObject[hitArea.id] = {
            animation: buildHitAreaAnimationArray(
              hitArea,
              getHitAreaKeyframesForAnimation(hitArea)
            ),
          };
        });
        return nextAnimationObject;
      });
    }
  };

  useEffect(() => {
    if (
      !openTimelinePopup.popupWindow &&
      Object.values(selectedComponent).length &&
      selectedComponent.hasOwnProperty("id")
    ) {
      if (
        selectedComponent?.componentStyles[popUpName] !==
        popUpOptions[popUpName]
      ) {
        let event1 = {
          target: {
            name: popUpName,
            value: popUpOptions[popUpName],
          },
        };
        handleChangeTimelineProps(event1, "blur");
      }
    }
  }, [openTimelinePopup.popupWindow]);
  const saveAnmObjWithedit = (e) => {
    let name = e.target.name;

    name = name === "left" ? "x" : name === "top" ? "y" : name;
    let n = marker / 45;
    let keyFrameRange = parseInt(n) + Math.ceil((n - Math.floor(n)) * 10) / 10;

    let selectedIndex = animationObject[
      selectedComponent.id
    ]?.animation?.findIndex(
      (elem) =>
        keyFrameRange <= elem.end + 0.1 && keyFrameRange >= elem.end - 0.1,
    );
    let tempAnmObj = {
      ...animationObject,
    };
    if (selectedIndex >= 0) {
      setundoFlag(false);
      let tempLayer = [...layerCompData];
      tempLayer.forEach((entry, index) => {
        if (entry.id === selectedComponent.id) {
          tempLayer[index].animationApllied = {
            keyFrameEdited: "true",
            keyFrameadded: "false",
            keyFrameDeleted: "false",
            componentAdded: "false",
            keyFramePasted: "false",
            marker: marker,
          };
        }
      });
      setEdited(true);
      setLayerCompData(tempLayer);
      setPopUpValuesEdited(true);
      tempAnmObj[selectedComponent.id].animation[selectedIndex][name] =
        e.target.value;
      setAnimationObject(tempAnmObj);
    }
  };

  const handleChangeTimelineProps = (e, blur) => {
    let name = e.target.name;
    const signedTimelineFields = [
      "left",
      "top",
      "translateX",
      "translateY",
      "rotation",
      "rotationX",
      "rotationY",
      "transformOriginX",
      "transformOriginY",
      "transformOriginZ",
    ];
    const isValidNegativeOne =
      signedTimelineFields.includes(name) &&
      String(e.target.value).trim() === "-1";
    let retVal = getValidInput(e, name, blur);
    if (clickedClose && blur === "blur") {
      retVal =
        popUpOptions?.[name] ?? selectedComponent?.componentStyles?.[name];
    }
    if (retVal === -1 && !isValidNegativeOne) return;

    retVal = sanitizeDecimalFieldValue(
      retVal,
      blur,
      TIMELINE_DECIMAL_FIELDS,
      name,
    );
    if (retVal === -1 && !isValidNegativeOne) return;

    if (blur === "blur" && (retVal == "-" || retVal == "-0")) {
      retVal = 0;
    }

    const timelineFields = [
      "left",
      "top",
      "width",
      "height",
      "translateX",
      "translateY",
      "rotationX",
      "rotationY",
      "rotation",
      "transformOriginX",
      "transformOriginY",
      "transformOriginZ",
    ];

    if (timelineFields.includes(name)) {
      setPopUpOptions({ ...popUpOptions, [name]: retVal });
      setPopUpName(name);

      if (shouldPreserveDecimalInput(retVal, blur)) return;

      if (
        name === "rotation" ||
        name === "rotationX" ||
        name === "rotationY"
      ) {
        const rotationVal = parseFloat(retVal);
        if (
          !Number.isNaN(rotationVal) &&
          (rotationVal < -360 || rotationVal > 360)
        ) {
          toast.error(
            <div className="notificationText">
              Rotation value should be in a range between -360 degree to +360
              degree.!
            </div>,
          );
          retVal = retVal > 360 ? 360 : -360;
          retVal = roundTo2Decimals(retVal);
        }
      }

      const targetLayerIndex = Array.isArray(layerCompData)
        ? layerCompData.findIndex((c) => c?.id === selectedComponent?.id)
        : -1;
      if (targetLayerIndex >= 0) {
        layerCompData[targetLayerIndex].eachDrag =
          blur === "blur" ? "no" : "yes";
      }
      setundoFlag(true);
      let tempSelected = {
        ...selectedComponent,
        componentStyles: {
          ...(selectedComponent?.componentStyles || {}),
        },
      };
      let popUpvalues = { ...popUpOptions, [name]: retVal };
      if ((name == "width" || name == "height") && isAspectRatioLocked) {
        handleCompAspectRatioPopup(tempSelected, popUpvalues, name, retVal);
      }
      popUpvalues[name] = retVal;
      tempSelected.componentStyles[name] = retVal || 0;

      setPopUpOptions(normalizeTimelinePopUpOptions(popUpvalues));
      setPopUpName(name);

      setSelectedComponent(tempSelected);
      let tempLayerComp = JSON.parse(JSON.stringify(layerCompData));
      tempLayerComp.forEach((comp, LayerCompIndex) => {
        if (comp.id === selectedComponent.id) {
          tempLayerComp[LayerCompIndex].componentStyles = {
            ...(comp.componentStyles || {}),
            ...tempSelected.componentStyles,
          };
        }
      });
      setLayerCompData(tempLayerComp);
      setPopUpValuesEdited(true);
    } else {
      if (!!Number(retVal)) {
        retVal = Number(retVal);
      }
      setPopUpName(name);
    }

    if (name === "skewAnimation") {
      let skewChecked = {
        ...popUpOptions,
        [name]: e.target.checked,
      };
    }
  };

  useEffect(() => {
    const cleanup = dragAndCalculate();
    return cleanup;
  }, []);

  useEffect(() => {
    if (appData?.genericInfo?.canvasScale !== undefined)
      setTotalDuration({ ...appData?.genericInfo?.canvasScale });
  }, [appData.updateGenericInfo]);
  function dragAndCalculate() {
    let elem = document.getElementById("layerCol");
    let markerElem = document.getElementById("marker");
    let timelineScaleElem = document.getElementById("timeline-scale");
    if (!elem || !markerElem || !timelineScaleElem) return () => {};
    const EDGE_SCROLL_THRESHOLD = 28;
    const EDGE_SCROLL_STEP = 14;
    const DRAG_START_THRESHOLD = 3;
    let isDragging = false;
    let dragStartClientX = 0;
    let grabOffsetX = 0;
    let hasDragged = false;
    let lastClientX = 0;
    let edgeScrollRaf = null;

    const getMaxMarkerLeft = () => getMaxMarkerLeftForSelectedLayer();

    const syncTimelineState = (nextLeft) => {
      const maxLeft = getMaxMarkerLeft();
      const clampedLeft = Math.max(0, Math.min(nextLeft, maxLeft));
      const markerInSeconds = clampedLeft / 45;
      let secondsToSet = Math.floor(markerInSeconds);
      const fractionalMs = Math.round((markerInSeconds - secondsToSet) * 100);
      let snappedMilliseconds = Math.round(fractionalMs / 10) * 10;

      if (snappedMilliseconds >= 100) {
        secondsToSet += 1;
        snappedMilliseconds = 0;
      }
      // At the selected layer's end, snap time to that end (not full canvas duration).
      if (clampedLeft >= maxLeft && maxLeft > 0) {
        const endSeconds = maxLeft / 45;
        secondsToSet = Math.floor(endSeconds);
        snappedMilliseconds =
          Math.round(((endSeconds - secondsToSet) * 100) / 10) * 10;
        if (snappedMilliseconds >= 100) {
          secondsToSet += 1;
          snappedMilliseconds = 0;
        }
      }

      const normalizedSeconds = secondsToSet < 0 ? 0 : secondsToSet;
      const prevState = lastTimelineStateRef.current;
      if (prevState.marker !== clampedLeft) {
        setMarker(clampedLeft);
        prevState.marker = clampedLeft;
      }
      if (prevState.seconds !== normalizedSeconds) {
        setSeconds(normalizedSeconds);
        prevState.seconds = normalizedSeconds;
      }
      if (prevState.milliseconds !== snappedMilliseconds) {
        setMillSeconds(snappedMilliseconds);
        prevState.milliseconds = snappedMilliseconds;
      }
    };

    // Absolute content-space position from pointer (avoids delta/scroll jump).
    const getMarkerLeftFromClientX = (clientX) => {
      const rect = elem.getBoundingClientRect();
      const valueLeft = Math.round(
        clientX - rect.left + elem.scrollLeft - grabOffsetX,
      );
      return Math.max(0, Math.min(valueLeft, getMaxMarkerLeft()));
    };

    const applyMarkerFromClientX = (clientX) => {
      const clampedLeft = getMarkerLeftFromClientX(clientX);
      sLeftRef.current = clampedLeft;
      syncTimelineState(clampedLeft);
      return clampedLeft;
    };

    const stopEdgeScroll = () => {
      if (edgeScrollRaf != null) {
        cancelAnimationFrame(edgeScrollRaf);
        edgeScrollRaf = null;
      }
    };

    const tickEdgeScroll = () => {
      edgeScrollRaf = null;
      if (!isDragging) return;

      const layerBounds = elem.getBoundingClientRect();
      const maxScroll = Math.max(0, elem.scrollWidth - elem.clientWidth);
      let scrolled = false;

      if (
        lastClientX >= layerBounds.right - EDGE_SCROLL_THRESHOLD &&
        elem.scrollLeft < maxScroll
      ) {
        elem.scrollLeft = Math.min(
          maxScroll,
          elem.scrollLeft + EDGE_SCROLL_STEP,
        );
        scrolled = true;
      } else if (
        lastClientX <= layerBounds.left + EDGE_SCROLL_THRESHOLD &&
        elem.scrollLeft > 0
      ) {
        elem.scrollLeft = Math.max(0, elem.scrollLeft - EDGE_SCROLL_STEP);
        scrolled = true;
      }

      if (scrolled) {
        applyMarkerFromClientX(lastClientX);
        edgeScrollRaf = requestAnimationFrame(tickEdgeScroll);
      }
    };

    const removeDragListeners = () => {
      document.removeEventListener("mousemove", divMove, true);
      document.removeEventListener("mouseup", mouseUp, true);
      window.removeEventListener("blur", mouseUp, true);
      stopEdgeScroll();
    };

    function mouseUp(e) {
      e.preventDefault();
      if (!isDragging || !document.getElementById("marker")) {
        removeDragListeners();
        return;
      }
      isDragging = false;
      stopEdgeScroll();
      if (!hasDragged) {
        removeDragListeners();
        return;
      }
      if (!playPause?.playPause) {
        syncTimelineState(sLeftRef.current);
      }
      SetPopupLeft(sLeftRef.current - 140 - elem.scrollLeft);
      removeDragListeners();
    }

    function mouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      isDragging = true;
      dragStartClientX = e.clientX;
      lastClientX = e.clientX;
      hasDragged = false;

      // Always read live position from ref (effect mounts once; `marker` is stale).
      const currentMarkerLeft = sLeftRef.current || 0;
      const rect = elem.getBoundingClientRect();
      grabOffsetX =
        e.clientX - (rect.left + currentMarkerLeft - elem.scrollLeft);

      setOpenTimelinePopup((prevState) =>
        prevState?.popupWindow
          ? {
              popupWindow: false,
              fromUnRedo: false,
            }
          : prevState,
      );
      // Only document listeners — window+document both fired and double-scrolled.
      document.addEventListener("mousemove", divMove, true);
      document.addEventListener("mouseup", mouseUp, true);
      window.addEventListener("blur", mouseUp, true);
    }

    function divMove(e) {
      if (!isDragging) return;
      if (!hasDragged) {
        const movedDistance = Math.abs(e.clientX - dragStartClientX);
        if (movedDistance < DRAG_START_THRESHOLD) return;
        hasDragged = true;
      }
      lastClientX = e.clientX;
      applyMarkerFromClientX(e.clientX);
      if (edgeScrollRaf == null) {
        edgeScrollRaf = requestAnimationFrame(tickEdgeScroll);
      }
    }

    markerElem.addEventListener("mousedown", mouseDown, false);
    return () => {
      markerElem.removeEventListener("mousedown", mouseDown, false);
      removeDragListeners();
      isDragging = false;
      hasDragged = false;
    };
  }
  useEffect(() => {
    layerCompData.map((value, index) => {
      if (!animationObject[value.id]) {
        resizeWdith("slider-TimeLine" + index, "ghostPane" + index);

        let temp;

        temp = Object.assign(animationObject, {
          [value.id]: {
            timeLine: { id: "slider-TimeLine" + index, left: 0 },
            animation: [],
          },
        });

        setAnimationObject(temp);
      }
    });
    if (layerCompData.length > 3) scroll();
    if (selectedComponent === "compdeleted" && layerCompData.length === 0) {
      setTotalDuration({ divisions: 30, width: 1359 });
      setMarker(0);
      setSeconds(0);
      setMillSeconds(0);
      appData.updateGenericInfo({
        ...appData?.genericInfo,
        canvasScale: { divisions: 30, width: 1359 },
        rightUpdaed: true,
      });
    }
  }, [layerCompData]);

  function resizeWdith(pane1, ghostpane1) {
    return;
  }

  const selectcomp = { ...selectedComponent };

  // Layer bar width must come from saved layerWidth only — never live draggerWidth,
  // or stretching the timeline visually grows the selected layer until remount.
  const DEFAULT_LAYER_BAR_WIDTH = 675;
  const getLayerBarWidth = (item) =>
    Math.max(47, toNumber(item?.componentStyles?.layerWidth, DEFAULT_LAYER_BAR_WIDTH));

  const returnPowerIconbgcolor = (compType) => {
    if (compType === "Text") {
      return "#83d89e";
    } else if (compType === "Button") {
      return "#f3cba5";
    } else if (compType === "Image") {
      return "#8dcbf7";
    } else if (compType === "Shape") {
      return "#be9da0";
    }
  };
  const [contextMenuPosition, setContextMenuPosition] = useState({
    x: 0,
    y: 0,
  });
  const [deletionLayer, setDeletionLyer] = useState();
  const handleRightClickonlayer = (event, item) => {
    event.preventDefault();
    setSelectedComponent(item);
    setDeletionLyer(item);

    let x = event.clientX;
    let y = event.clientY;

    const availableSpaceBottom = window.innerHeight - y;
    let adjustedX = x;
    let adjustedY = y;
    if (availableSpaceBottom < 64) {
      adjustedY = y - 64;
    }
    setContextMenuPosition({
      x: adjustedX, //x,
      y: adjustedY, //y,
    });

    setContextMenuvisibility(true);
    setCopyPasteContextMenuVisibility(false);
  };
  const handleHideLayerContextMenu = () => {
    setContextMenuvisibility(false);
  };
  const handleDeleteallKeyframe = () => {
    const keyFramesToDelete =
      animationObject[selectedComponent.id]?.animation || [];
    const isCopiedKeyFrameDeleted =
      copiedKeyFrame !== "" && keyFramesToDelete.includes(copiedKeyFrame);

    let tempSelectedkeyframes = { ...selectedComponent };
    tempSelectedkeyframes.keyFrames = [];
    setSelectedComponent(tempSelectedkeyframes);
    const tempElemLayers = layerCompData.map((entry) => {
      if (entry.id === selectedComponent.id) {
        return {
          ...entry,
          keyFrames: [],
        };
      }
      return entry;
    });

    setAnimationObject((prevAnmObj) => ({
      ...prevAnmObj,
      [selectedComponent.id]: {
        ...prevAnmObj[selectedComponent.id],
        animation: [],
      },
    }));
    if (isCopiedKeyFrameDeleted) {
      setCopiedKeyFrame("");
      setCopyPropertySelected(false);
    }
    setLayerCompData(tempElemLayers);
    setContextMenuvisibility(false);
  };

  const handlePowerIconClick = (e, id, component = selectedComponent) => {
    e.stopPropagation();
    if (!playPause?.animationCompleted) return;
    if (!validateActionEdit(component)) return;
 

    // Keep flash-icon interaction deterministic: click toggles popup open/close.
    if (
      openTimelinePopup?.popupWindow &&
      keyFrameClicked === "plusCustomAnmn"
    ) {
      setOpenTimelinePopup({
        popupWindow: false,
        fromUnRedo: false,
      });
      setIsNewAnimationOpen(false);
      return;
    }

    setIsNewAnimationOpen(true);
    openCustomAnmnPopup();
    setKeyFrameClicked("plusCustomAnmn");

    let pointerLeft =
      e.clientX -
      document.getElementById(id).getBoundingClientRect().left -
      document.getElementById(id).getBoundingClientRect().width / 2;
    let pointerTop =
      e.clientY -
      document.getElementById(id).getBoundingClientRect().top -
      document.getElementById(id).getBoundingClientRect().width / 2;
    setPopWindowPosn({
      left: e.clientX - pointerLeft,
      top: e.clientY - pointerTop,
    });
  };

  const handleKeyDroIconClick = (e, id) => {
    playPause?.animationCompleted && setElementPopUp(!elementPopUp);
    setPopWindowPosn({
      left: e.clientX,
      top: e.clientY,
    });
  };

  const getLayerStyle = () => {
    const scalewidth = totalDuration?.divisions;
    switch (scalewidth) {
      case 30:
        return "animation30";
      case 40:
        return "animation40";
      case 50:
        return "animation50";
      case 60:
        return "animation60";
      case 70:
        return "animation70";
      case 80:
        return "animation80";
      case 90:
        return "animation90";
      default:
        return "";
    }
  };

  const [layerCompDataPrevLength, setLayerCompDataPrevLength] = useState(0);
  useEffect(() => {
    if (layerCompData.length > layerCompDataPrevLength) {
      setMarker(0);
      setSeconds(0);
      setMillSeconds(0);
    }

    setLayerCompDataPrevLength(layerCompData.length);
  }, [layerCompData, layerCompDataPrevLength]);

  //copy paste key frame functionality

  const handleContextMenu = (event) => {
    event.preventDefault();
    const x = event.clientX;
    const y = event.clientY;
    setCopyPasteContextMenuPosition({ x, y });
    setCopyPasteContextMenuVisibility(true);
    setContextMenuvisibility(false);
    setOpenTimelinePopup({
      popupWindow: false,
      fromUnRedo: false,
    });
  };
  useEffect(() => {}, [selectedProperties]);

  const handleOutsideClick = () => {
    setCopyPasteContextMenuVisibility(false);
  };

  const copyKeyFrames = () => {
    setCopyPropertySelected(true);
    setCopiedKeyFrame(
      animationObject[selectedProperties.id]?.animation[
        selectedPropertiesIndex.keyIndex
      ],
    );
    toast.success(
      <div className="notificationText d-flex">
        {t("Keyframe Copied Successfully")}
      </div>,
    );
  };
  const pasteKeyFrame = () => {
    if (!selectedProperties.hasOwnProperty("id")) {
      toast.error(
        <div className="notificationText">
          {t("Please select the component")}
        </div>,
      );
      return;
    }
    if (copiedKeyFrame === "") {
      toast.error(
        <div className="notificationText">{t("No Key frame is copied")}</div>,
      );
      return;
    }

    let tempLayer = [...layerCompData];
    let tempAnmObj = {
      ...animationObject,
    };
    let anmAry = tempAnmObj[selectedProperties.id]?.animation;

    let tempCopiedKeyFrame = { ...copiedKeyFrame };

    anmAry[selectedPropertiesIndex.keyIndex].x = tempCopiedKeyFrame.x;
    anmAry[selectedPropertiesIndex.keyIndex].y = tempCopiedKeyFrame.y;
    anmAry[selectedPropertiesIndex.keyIndex].width = tempCopiedKeyFrame.width;
    anmAry[selectedPropertiesIndex.keyIndex].height = tempCopiedKeyFrame.height;
    anmAry[selectedPropertiesIndex.keyIndex].rotation =
      tempCopiedKeyFrame.rotation;
    anmAry[selectedPropertiesIndex.keyIndex].rotationX =
      tempCopiedKeyFrame.rotationX;
    anmAry[selectedPropertiesIndex.keyIndex].rotationY =
      tempCopiedKeyFrame.rotationY;
    anmAry[selectedPropertiesIndex.keyIndex].opacity =
      tempCopiedKeyFrame.opacity;
    anmAry[selectedPropertiesIndex.keyIndex].transform =
      tempCopiedKeyFrame.transform;
    anmAry[selectedPropertiesIndex.keyIndex].translateX =
      tempCopiedKeyFrame.translateX;
    anmAry[selectedPropertiesIndex.keyIndex].translateY =
      tempCopiedKeyFrame.translateY;

    tempLayer[selectedPropertiesIndex.index].componentStyles.left =
      tempCopiedKeyFrame.x;
    tempLayer[selectedPropertiesIndex.index].componentStyles.top =
      tempCopiedKeyFrame.y;
    tempLayer[selectedPropertiesIndex.index].componentStyles.height =
      tempCopiedKeyFrame.height;
    tempLayer[selectedPropertiesIndex.index].componentStyles.width =
      tempCopiedKeyFrame.width;

    setSelectedComponent((prevState) => ({
      ...prevState,
      componentStyles: {
        ...prevState.componentStyles,
        left: tempCopiedKeyFrame.x,
        top: tempCopiedKeyFrame.y,
        width: tempCopiedKeyFrame.width,
        height: tempCopiedKeyFrame.height,
        rotationX: tempCopiedKeyFrame.rotationX || 0,
        rotationY: tempCopiedKeyFrame.rotationY || 0,
        translateX: tempCopiedKeyFrame.translateX || 0,
        translateY: tempCopiedKeyFrame.translateY || 0,
        transformOriginX: tempCopiedKeyFrame.transformOriginX || 0,
        transformOriginY: tempCopiedKeyFrame.transformOriginY || 0,
        transformOriginZ: tempCopiedKeyFrame.transformOriginY || 0,
      },
    }));

    let popUpvalues = {
      ...popUpOptions,
      left: tempCopiedKeyFrame.x,
      top: tempCopiedKeyFrame.y,
      width: tempCopiedKeyFrame.width,
      height: tempCopiedKeyFrame.height,
      ease: tempCopiedKeyFrame.ease,
      skewAnimation: tempCopiedKeyFrame.skewAnimation,
      opacity: Math.round(tempCopiedKeyFrame.opacity * 100),
      rotation: tempCopiedKeyFrame.rotation,
      rotationX: tempCopiedKeyFrame.rotationX || 0,
      rotationY: tempCopiedKeyFrame.rotationY || 0,
      scale: Math.round(tempCopiedKeyFrame.transform * 100),
      translateX: tempCopiedKeyFrame.translateX || 0,
      translateY: tempCopiedKeyFrame.translateY || 0,
      transformOriginX: tempCopiedKeyFrame.transformOriginX || 0,
      transformOriginY: tempCopiedKeyFrame.transformOriginY || 0,
      transformOriginZ: tempCopiedKeyFrame.transformOriginY || 0,
    };
    setPopUpOptions(popUpvalues);
    setAnimationObject(tempAnmObj);
    setLayerCompData(tempLayer);
    toast.success(
      <div className="notificationText d-flex">
        {t("Keyframe Pasted Successfully")}
      </div>,
    );
  };

  const deleteKeyFrame = () => {
    if (
      !selectedProperties?.id ||
      selectedPropertiesIndex?.index === undefined ||
      selectedPropertiesIndex?.keyIndex === undefined
    ) {
      return;
    }

    const componentId = selectedProperties.id;
    const layerIndex = selectedPropertiesIndex.index;
    const keyIndex = selectedPropertiesIndex.keyIndex;
    const keyFrameToDelete =
      animationObject[componentId]?.animation?.[keyIndex];
    const isDeletedKeyFrameCopied =
      copiedKeyFrame !== "" && copiedKeyFrame === keyFrameToDelete;

    const updatedLayerCompData = layerCompData.map((layer, index) => {
      if (index !== layerIndex) return layer;
      return {
        ...layer,
        keyFrames: (layer.keyFrames || []).filter((_, i) => i !== keyIndex),
      };
    });
    const updatedAnimationObject = {
      ...animationObject,
      [componentId]: {
        ...animationObject[componentId],
        animation: (animationObject[componentId]?.animation || []).filter(
          (_, i) => i !== keyIndex,
        ),
      },
    };
    setLayerCompData(updatedLayerCompData);
    setAnimationObject(updatedAnimationObject);
    setSelectedComponent((prevState) => {
      if (prevState?.id !== componentId) return prevState;
      return {
        ...prevState,
        keyFrames: (prevState?.keyFrames || []).filter(
          (_, i) => i !== keyIndex,
        ),
      };
    });

    if (isDeletedKeyFrameCopied) {
      setCopiedKeyFrame("");
      setCopyPropertySelected(false);
    }
    toast.success(
      <div className="notificationText d-flex">
        {t("Keyframe Deleted Successfully")}
      </div>,
    );
    handleTimelinePopup(true);
  };

  const handleSelectedComponentKeyframe = (item, keyIndex) => {
    if (
      keyFrameClicked !== "plusCustomAnmn" &&
      keyFrameClicked !== "Diamond+Icon"
    ) {
      const tempSelectedComponent = item;
      tempSelectedComponent.componentStyles.left =
        animationObject[item?.id]?.animation[keyIndex]?.x;
      tempSelectedComponent.componentStyles.top =
        animationObject[item?.id]?.animation[keyIndex]?.y;
      tempSelectedComponent.componentStyles.translateX =
        animationObject[item?.id]?.animation[keyIndex]?.translateX;
      tempSelectedComponent.componentStyles.translateY =
        animationObject[item?.id]?.animation[keyIndex]?.translateY;
      setSelectedComponent(tempSelectedComponent);
    }
  };
  return (
    <>
      <div
        className="layerColdiv custonHorizontalScrollBar"
        onClick={handleOutsideClick}
        ref={layerColDivRef}
      >
        <div className="layerCol " id="layerCol">
          <div
            className="marker"
            id="marker"
            style={{ left: marker-2, marginTop: 4 }}
            onMouseMove={() => {
              if (!mouseUpOnTimeline) {
                setIsResizing(true);
              }
            }}
          >
            <div className="marker-head"></div>

            <div className="marker-tail"></div>
          </div>{" "}
          <div className="scale-IncrementalButton">
            <Canvas
              totalDuration={totalDuration}
              draggerWidth={draggerWidth}
              setDraggerWidth={setDraggerWidth}
              isResizing={isResizing}
              setIsResizing={setIsResizing}
              setMousUpOnTimeline={setMousUpOnTimeline}
              appData={appData}
              layerCompData={layerCompData}
              playPause={playPause}
            />
          </div>
          <div
            className="animationScroll"
            id="parentID"
            style={{
              width: totalDuration.width + 10,
            }}
          >
            <div
              className="animate-row custonVertScrollBar"
              id="scrollDiv"
              draggable={false}
              style={{
                overflowY: "scroll",
                overflowX: "hidden",
                cursor: !playPause.animationCompleted ? "default" : undefined,
              }}
            >
              {layerCompData.length !== 0 ? (
                <>
                  {layerCompData?.map((item, index) => {
                    return (
                      <div
                        className={`col-md-12 animation-timelineContent pd-0 contextmenu ${getLayerStyle()}`}
                        key={item.id}
                        style={{
                          cursor: !playPause.animationCompleted
                            ? "default"
                            : undefined,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (playPause.animationCompleted) {
                            setSelectedComponent(item);
                            handleCtrlClick(e, item);
                          }
                        }}
                      >
                        {item?.keyFrames?.map((key, keyIndex) => (
                          <div
                            key={`${item.id}-${key}-${keyIndex}`}
                            style={{
                              left: key + 5 + "px",
                              pointerEvents: !playPause.animationCompleted
                                ? "none"
                                : "auto",
                              cursor: !playPause.animationCompleted
                                ? "default"
                                : "pointer",
                            }}
                            className="key-drops"
                            id="key-drops"
                            onContextMenu={(e) => {
                              if (
                                playPause.animationCompleted &&
                                validateActionEdit(item)
                              ) {
                                handleContextMenu(e);
                                setSelectedPropertiesIndex({
                                  index: index,
                                  keyIndex: keyIndex,
                                });
                                setSelectedProperties(item);
                                setMultiSelectedComps([]);
                              }
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              // While animation is playing, ignore keyframe clicks.
                              if (!playPause.animationCompleted) return;
                              setSelectedComponent(item);
                              if (validateActionEdit(item) && !e.ctrlKey) {
                                setKeyFrameClicked(keyIndex);
                                handleTimelinePopup();
                                handleKeyDroIconClick(e, "key-drops");
                                handleOutsideClick();
                                setSelectedProperties(item);
                                setSelectedPropertiesIndex({
                                  index: index,
                                  keyIndex: keyIndex,
                                });
                                setIsNewAnimationOpen(false);
                                handleSelectedComponentKeyframe(item, keyIndex);
                              }
                            }}
                          ></div>
                        ))}
                        {item.id === selectcomp?.id ? (
                          <Rnd
                            style={{
                              position: "relative",
                            }}
                            enableResizing={{
                              top: false,
                              // Lock layer handle while the timeline bar is being dragged.
                              right: !isResizing,
                              bottom: false,
                              left: false,
                              topRight: false,
                              bottomRight: false,
                              bottomLeft: false,
                              topLeft: false,
                            }}
                            onResize={(e, direction, ref) => {
                              if (isResizing) return;
                              const timelineLimit = Math.max(
                                47,
                                toNumber(draggerWidth, 0),
                              );
                              const nextWidth = Math.min(
                                Math.max(47, toNumber(ref?.offsetWidth, 0)),
                                timelineLimit,
                              );
                              layerResizeDraftWidthRef.current = nextWidth;
                              setLayerResizeDraftWidth(nextWidth);
                            }}
                            onResizeStop={(
                              e,
                              direction,
                              ref,
                              delta,
                              position,
                            ) => {
                              const finalWidth =
                                layerResizeDraftWidthRef.current ||
                                toNumber(ref?.offsetWidth, 0);
                              layerResizeDraftWidthRef.current = null;
                              setLayerResizeDraftWidth(null);
                              callOnResizeStop(
                                e,
                                direction,
                                ref,
                                delta,
                                position,
                                finalWidth,
                              );
                            }}
                            // Controlled size from saved layerWidth only — never follow draggerWidth.
                            size={{
                              width:
                                layerResizeDraftWidth ??
                                getLayerBarWidth(item),
                              height: 30,
                            }}
                            position={{ x: 0, y: 0 }}
                            minWidth={47}
                            maxWidth={draggerWidth}
                            minHeight={30}
                            draggablehandle={`.${"resize-timeLine"}, .${"dragHandle"}`}
                            resizeHandleStyles={{
                              right: {
                                zIndex: "99999",
                                cursor: "ew-resize",
                              },
                              left: {
                                cursor: "ew-resize",
                                zIndex: "99999",
                              },
                            }}
                            disableDragging
                          >
                            <div
                              id={"slider-TimeLine" + index}
                              className="resize-timeLine slider-TimeLine"
                              onContextMenu={(e) => {
                                handleRightClickonlayer(e, item);
                              }}
                              ref={layercontextMenuRef}
                              style={{
                                backgroundColor: item?.componentStyles?.BGColor,
                                width: "100%",
                                height: "100%",
                              }}
                            >
                              {item?.id === selectcomp.id && (
                                <>
                                  {" "}
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      height: "100%",
                                      cursor: "ew-resize",
                                      zIndex: "99999",
                                    }}
                                  ></div>
                                  <img
                                    src={Dragger}
                                    alt=""
                                    className="img-fluid draggerIcon"
                                  />
                                  {!selectcomp?.keyFrames?.length && (
                                    <div
                                      id={"slider-powericon" + index}
                                      className=" slider-TimeLine powerIcon1"
                                      style={{
                                        backgroundColor: returnPowerIconbgcolor(
                                          item?.componentType,
                                        ),
                                      }}
                                    >
                                      <img
                                        src={Powericon}
                                        alt=""
                                        className="img-fluid "
                                        id="powerIconCircle"
                                        onClick={(e) => {
                                          handlePowerIconClick(
                                            e,
                                            "powerIconCircle",
                                            item
                                          );
                                        }}
                                      />
                                    </div>
                                  )}
                                  {!selectcomp?.keyFrames?.length && (
                                    <div
                                      id={"slider-powericon" + index}
                                      className="powerIcon2"
                                      style={{
                                        backgroundColor: returnPowerIconbgcolor(
                                          item?.componentType,
                                        ),
                                      }}
                                    >
                                      {" "}
                                      <img
                                        src={Powericon}
                                        alt=""
                                        className="img-fluid"
                                        id="powerIconCircle2"
                                        onClick={(e) => {
                                          handlePowerIconClick(
                                            e,
                                            "powerIconCircle2",
                                            item
                                          );
                                        }}
                                      />
                                    </div>
                                  )}
                                  <img
                                    src={Dragger}
                                    alt=""
                                    className="img-fluid draggerIcon2"
                                  />
                                </>
                              )}
                            </div>
                          </Rnd>
                        ) : (
                          <div
                            style={{
                              position: "relative",
                              width: `${getLayerBarWidth(item)}px`,
                              height: 30,
                            }}
                          >
                            <div
                              id={"slider-TimeLine" + index}
                              className="resize-timeLine slider-TimeLine"
                              style={{
                                backgroundColor: item?.componentStyles?.BGColor,
                                width: "100%",
                                height: "100%",
                              }}
                            >
                              <div
                                id={"slider-powericon" + index}
                                className=" slider-TimeLine NopowerIcon1"
                                style={{
                                  backgroundColor: returnPowerIconbgcolor(
                                    item?.componentType,
                                  ),
                                }}
                              ></div>
                              <div
                                id={"slider-powericon" + index}
                                className="NopowerIcon2"
                                style={{
                                  backgroundColor: returnPowerIconbgcolor(
                                    item?.componentType,
                                  ),
                                }}
                              ></div>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </>
              ) : (
                <div
                  className={`col-md-12 animation-timelineContent pd-0  ${getLayerStyle()}`}
                >
                  {" "}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {openTimelinePopup.popupWindow && (
        <CustomanimationPopup
          layerCompData={layerCompData}
          setLayerCompData={setLayerCompData}
          handleTimelinePopup={handleTimelinePopup}
          marker={popUpLeft}
          markerTime={marker}
          selectedComponent={selectedComponent}
          SetPopupLeft={SetPopupLeft}
          setSelectedComponent={setSelectedComponent}
          popUpOptions={popUpOptions}
          setPopUpOptions={setPopUpOptions}
          animationObject={animationObject}
          setAnimationObject={setAnimationObject}
          copiedKeyFrame={copiedKeyFrame}
          setCopiedKeyFrame={setCopiedKeyFrame}
          setEdited={setEdited}
          setundoFlag={setundoFlag}
          popUpValuesEdited={popUpValuesEdited}
          setPopUpValuesEdited={setPopUpValuesEdited}
          openTimelinePopup={openTimelinePopup}
          setOpenTimelinePopup={setOpenTimelinePopup}
          handleChangeTimelineProps={handleChangeTimelineProps}
          saveAnmObjWithedit={saveAnmObjWithedit}
          elementPopUp={elementPopUp}
          setElementPopUp={setElementPopUp}
          addKeyFrames={addKeyFrames}
          setMarker={setMarker}
          setSeconds={setSeconds}
          setMillSeconds={setMillSeconds}
          showTooltip={showTooltip}
          setShowTooltip={setShowTooltip}
          clickedClose={clickedClose}
          setClickedClose={setClickedClose}
          keyFrameClicked={keyFrameClicked}
          setKeyFrameClicked={setKeyFrameClicked}
          updateKeyFrames={updateKeyFrames}
          popUpWindowPosn={popUpWindowPosn}
          setPopWindowPosn={setPopWindowPosn}
          setCopyPropertySelected={setCopyPropertySelected}
          copyPropertySelected={copyPropertySelected}
          selectedProperties={selectedProperties}
          isNewAnimationOpen={isNewAnimationOpen}
          setIsNewAnimationOpen={setIsNewAnimationOpen}
          selectedPropertiesIndex={selectedPropertiesIndex}
          openCustomAnmnPopup={openCustomAnmnPopup}
        />
      )}
      {contextMenuvisbility &&
        (playPause.animationCompleted &&
        (multiSelectedComps.length > 0 ||
          selectedComponent?.componentType !== "default") ? (
          <LayerContextmenu
            contextMenuvisbility={contextMenuvisbility}
            setContextMenuvisibility={setContextMenuvisibility}
            contextMenuPosition={contextMenuPosition}
            handleHideLayerContextMenu={handleHideLayerContextMenu}
            handleDeleteallKeyframe={handleDeleteallKeyframe}
            handleDeleteLayer={deleteComponentOnCanvas}
            layercontextMenuRef={layercontextMenuRef}
            playPause={playPause}
            multiSelectedComps={multiSelectedComps}
            setContextMenuPosition={setContextMenuPosition}
            selectedComponent={selectedComponent}
            deletionLayer={deletionLayer}
            setSelectedComponent={setSelectedComponent}
          />
        ) : null)}
      {copyPasteContextMenuVisibility && (
        <CopyPasteContextMenu
          isVisible={copyPasteContextMenuVisibility}
          position={copyPasteContextMenuPosition}
          handleOutsideClick={handleOutsideClick}
          setCopyPasteContextMenuVisibility={setCopyPasteContextMenuVisibility}
          copyKeyFrames={copyKeyFrames}
          pasteKeyFrame={pasteKeyFrame}
          deleteKeyFrame={deleteKeyFrame}
          copyPropertySelected={copyPropertySelected}
        />
      )}
    </>
  );
}

export default Layers;

